import React from 'react';
import { EChartsWrapper } from './echarts-wrapper';
import { createBarChartOption } from '../lib/chart-options';
import type { TopItemsData } from '@/entities/dashboard';

interface BarChartProps {
  data: TopItemsData;
  height?: number | string;
  className?: string;
  loading?: boolean;
}

export const BarChart: React.FC<BarChartProps> = ({ data, height, className, loading }) => {
  const option = createBarChartOption(data);

  return <EChartsWrapper option={option} height={height} className={className} loading={loading} />;
};
